import { Panel } from './panel.js';
import MeasureView from './MeasureView.svelte';

class MeasurePanel extends Panel {
  constructor(opt_options) {
    var options = opt_options || {};
    if (!options.className) {
      options.className = 'measure-panel';
    }
    options.title = 'Measure';
    super(options);
    this.view = new MeasureView({
      target: this.panel,
      props: {
        dispatch: (evt) => {
          this.dispatch(evt);
        }
      }
    });
  }

  handleCloseClick() {
    // Instead of hiding, dispatch an event and let the listener
    // determine if the panel should be hidden
    this.dispatchEvent({
      type: 'measure-panel-close'
    });
  }

  show() {
    this.reset();
    super.show();
  }

  hide() {
    super.hide();
    this.reset();
  }

  reset() {
    this.setProps({
      mode: 'choose',
      length: null,
      area: null
    });
  }

  setProps(props) {
    this.view.$set(props);
  }

  dispatch(evt) {
    evt = (evt.type) ? evt : {type: evt};
    this.dispatchEvent(evt);
  }

}

export { MeasurePanel };
